'use client';

import { useSession } from "next-auth/react";

export const AvatarName = () => {
  const { data: session } = useSession();
  const inicials = session?.user?.name || '';

  return (
    <div className="w-12 h-12 flex justify-center items-center rounded-full bg-gray-800 border border-gray-800 cursor-pointer">
      <span className="select-none text-md font-medium [word-spacing:-3px]">{inicials}</span>
    </div>
  )
}